export const testimonials = [
  {
    name: 'Sarah Mitchell, DDS',
    role: 'General Dentist · Austin, TX',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5fe781a6-41c3-4324-a2b8-0d146eba11e7.jpg',
    quote:
      'I used to open three or four references before every case discussion. Having the Master Map and the worksheets in one place made my preparation feel far more organized.',
  },
  {
    name: 'James Carter',
    role: 'Final-Year Dental Student · Ohio',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/98704057-2086-4a88-a870-1b646425adb8.jpg',
    quote:
      'The radiographic observation worksheet helped me separate what I actually saw from what I was assuming. My case presentations got a lot cleaner and easier to follow.',
  },
  {
    name: 'Priya Nair, DMD',
    role: 'Associate Dentist · New Jersey',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/fb77dba3-2e6b-4971-a882-386e594537d8.jpg',
    quote:
      'The information-gap worksheet is my favorite part. It makes me write down what I still don’t know before jumping to conclusions — exactly the habit I wanted to build.',
  },
  {
    name: 'Michael O’Connor, DDS',
    role: 'Dentist & Clinical Instructor · Chicago, IL',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6a07f869-b530-44fe-b0dc-b67bd6b29da3.jpg',
    quote:
      'I’ve started using the case presentation outline with my students. Everyone follows the same structure, so our discussions stay focused on the reasoning, not on the format.',
  },
];
